import { render, staticRenderFns } from "./StoreComparisonChart.vue?vue&type=template&id=440fae79"
import script from "./StoreComparisonChart.vue?vue&type=script&lang=js"
export * from "./StoreComparisonChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports